// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metricsFieldsBlock__tZwFP {
  width: 100%;
}

.metricsFieldsTitle__lNtex {
  font-size: 11px;
  line-height: 13px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.metricsFieldsWrapper__Pu6sE {
  width: 100%;
  margin-top: 10px;
  display: flex;
  align-items: center;
  background: var(--tables-secondary-row-sub-title-surface);
}
@media (max-width: 900px) {
  .metricsFieldsWrapper__Pu6sE {
    flex-direction: column;
    padding: 15px 25px;
  }
}

.metricsFields__Evn7T {
  width: 100%;
  padding: 15px 10px 15px 25px;
  display: flex;
  align-items: center;
  gap: 15px;
}
@media (max-width: 900px) {
  .metricsFields__Evn7T {
    padding: 0 0 10px;
  }
}

.metricsTotal__ZUarQ {
  width: 100%;
  padding: 15px 25px 15px 10px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-left: 1px solid var(--tables-primary-row-stroke);
}
@media (max-width: 900px) {
  .metricsTotal__ZUarQ {
    padding: 10px 0 0;
    border-left: none;
    border-top: 1px solid var(--tables-primary-row-stroke);
  }
}

.fieldExtra__p1Wz2 {
  font-size: 12px;
  line-height: 20px;
  color: var(--tables-primary-row-text-additional);
  text-transform: lowercase;
  white-space: nowrap;
}

.fieldExtraRight__A9wz1 {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/MetricsFields/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yDAAA;AAzEF;AA2EE;EAPF;IAQI,sBAAA;IACA,kBAAA;EAxEF;AACF;;AA2EA;EACE,WAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAxEF;AA0EE;EAPF;IAQI,iBAAA;EAvEF;AACF;;AA0EA;EACE,WAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uDAAA;AAvEF;AAyEE;EARF;IASI,iBAAA;IACA,iBAAA;IACA,sDAAA;EAtEF;AACF;;AAyEA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,yBAAA;EACA,mBAAA;AAtEF;;AAyEA;EACE,iBAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.metricsFieldsBlock {\n  width: 100%;\n}\n\n.metricsFieldsTitle {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.metricsFieldsWrapper {\n  width: 100%;\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  background: var(--tables-secondary-row-sub-title-surface);\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    padding: 15px 25px;\n  }\n}\n\n.metricsFields {\n  width: 100%;\n  padding: 15px 10px 15px 25px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n\n  @media (max-width: 900px) {\n    padding: 0 0 10px;\n  }\n}\n\n.metricsTotal {\n  width: 100%;\n  padding: 15px 25px 15px 10px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  border-left: 1px solid var(--tables-primary-row-stroke);\n\n  @media (max-width: 900px) {\n    padding: 10px 0 0;\n    border-left: none;\n    border-top: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.fieldExtra {\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--tables-primary-row-text-additional);\n  text-transform: lowercase;\n  white-space: nowrap;\n}\n\n.fieldExtraRight {\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"metricsFieldsBlock": `metricsFieldsBlock__tZwFP`,
	"metricsFieldsTitle": `metricsFieldsTitle__lNtex`,
	"metricsFieldsWrapper": `metricsFieldsWrapper__Pu6sE`,
	"metricsFields": `metricsFields__Evn7T`,
	"metricsTotal": `metricsTotal__ZUarQ`,
	"fieldExtra": `fieldExtra__p1Wz2`,
	"fieldExtraRight": `fieldExtraRight__A9wz1`
};
module.exports = ___CSS_LOADER_EXPORT___;
